import { useEffect, useRef, useState } from "react";
import { Play, Film } from "lucide-react";
import {
  ABOUT_POSTER,
  ABOUT_VIDEO_SOURCES,
  ABOUT_MAX_MB,
  warnIfOversize,
} from "@/config/media";

// Optional 16:9 founder clip. Click-to-play (NOT autoplay), play-button overlay.
// Shows a clearly-marked slot when no asset is configured.
export const FounderVideo = () => {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);
  const hasVideo = ABOUT_VIDEO_SOURCES.length > 0;

  useEffect(() => {
    warnIfOversize(ABOUT_VIDEO_SOURCES, ABOUT_MAX_MB);
  }, []);

  const handlePlay = () => {
    setPlaying(true);
    requestAnimationFrame(() => videoRef.current && videoRef.current.play());
  };

  return (
    <div
      data-testid="about-video-slot"
      className="relative w-full aspect-video bg-charcoal border border-charcoal/15 overflow-hidden"
    >
      {playing && hasVideo ? (
        <video
          ref={videoRef}
          data-testid="about-video"
          className="absolute inset-0 w-full h-full object-cover"
          controls
          playsInline
          preload="metadata"
          poster={ABOUT_POSTER || undefined}
        >
          {ABOUT_VIDEO_SOURCES.map((s) => (
            <source key={s.src} src={s.src} type={s.type} />
          ))}
        </video>
      ) : (
        <button
          type="button"
          data-testid="about-video-play"
          onClick={hasVideo ? handlePlay : undefined}
          disabled={!hasVideo}
          aria-label={hasVideo ? "Play founder video" : "Founder video slot — asset pending"}
          className="absolute inset-0 w-full h-full flex flex-col items-center justify-center text-center group"
          style={
            ABOUT_POSTER
              ? {
                  backgroundImage: `url(${ABOUT_POSTER})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }
              : undefined
          }
        >
          {ABOUT_POSTER && <span className="absolute inset-0 bg-charcoal/40" />}
          <span className="relative inline-flex items-center justify-center w-16 h-16 border border-canvas/40 text-canvas transition-colors duration-300 group-hover:border-gold group-hover:text-gold">
            {hasVideo ? <Play className="w-6 h-6 ml-0.5" strokeWidth={1.4} /> : <Film className="w-6 h-6" strokeWidth={1.2} />}
          </span>
          <span className="relative mt-4 font-sans text-[11px] tracking-[0.22em] uppercase text-canvas/70">
            {hasVideo ? "Watch — Founder" : "Video Slot — Asset Pending"}
          </span>
          {!hasVideo && (
            <span className="relative mt-1.5 font-sans text-[11px] tracking-[0.14em] text-canvas/40">
              16:9 · under 15 MB
            </span>
          )}
        </button>
      )}
    </div>
  );
};
